module.exports = __webpack_public_path__ + "img/spin.19c896b0.png";